// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"86444fd4","726":"df6944bb"}[chunkId] + ".chunk.js";
};